import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as actions from './actions/'
import { createStore,combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { getAll } from './actions/actionMethod';


const dataReducer =(state = [],action)=>{
  switch(action.type){
    case actions.GET_DATA :
     return state.data; 
    break
    case actions.GET_DATA_KEY:
     return state.key
    break
    case actions.SET_DATA:
      state.push(action.data)
     return state  
    break 
    case actions.SET_DATA_KEY:
      state.push(action.data)
      return state
    break 
    case actions.GET_ALL :
      return state
    break  
  }
}

const store = createStore(dataReducer);
store.dispatch(getAll())

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
